var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 70,
    viewBox: "0 0 68 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5623 58.1406L56.8123 68.8906C56.2264 69.4766 55.2771 69.4766 54.6912 68.8906C54.1053 68.3047 54.1053 67.3554 54.6912 66.7695L62.2615 59.1992C32.5815 59.5273 17.2695 44.4492 9.61351 31.4492C1.04711 16.9022 0.0393078 2.21122 0.000207872 1.59422C-0.0505731 0.766106 0.574428 0.0551148 1.40251 0.00441754C1.43376 0.000511295 1.46501 0.000518927 1.50016 0.00051893C2.28532 0.000518999 2.94546 0.609894 2.99626 1.40672C3.00408 1.55125 4.01576 16.0867 12.258 30.0197C22.903 48.0197 40.133 56.8127 63.488 56.1837L53.9372 46.629C53.3512 46.0431 53.3512 45.0938 53.9372 44.5079C54.2301 44.215 54.6129 44.0704 54.9997 44.0704C55.3825 44.0704 55.7692 44.215 56.0622 44.5079L67.5702 56.0199C68.1483 56.6059 68.1482 57.5547 67.5623 58.1406Z",
    fill: "#D9D9DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArrow);
export default __webpack_public_path__ + "static/media/vectorArrow.eeb403395a23a95609770649cd6e7f3c.svg";
export { ForwardRef as ReactComponent };